import {Component, OnDestroy} from '@angular/core';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {AuthService} from '../../services/auth.service';
import {PasswordFieldType} from '../../../../core/interfaces/password-field-type';
import {PasswordFieldIconType} from '../../../../core/interfaces/password-field-icon-type';
import {catchError, switchMap, tap} from 'rxjs/operators';
import {TokenStorageService} from '../../services/token-storage.service';
import {EMPTY, Subject} from 'rxjs';
import {Router} from '@angular/router';
import {MatDialogRef} from '@angular/material/dialog';
import {LoginAndRegDialogComponent} from '../login-and-reg-dialog/login-and-reg-dialog.component';
import {NotificationService} from '../../../../core/services/notification.service';
import {LoginData} from '../../../../core/interfaces/login-data';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnDestroy {
  private unsubscribe$ = new Subject<void>();

  public form = this.formBuilder.group({
    username: [null, [Validators.required]],
    password: [null, [Validators.required]],
    rememberMe: [true],
  });

  public isShowPassword = false;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly authService: AuthService,
    private readonly tokenStorageService: TokenStorageService,
    private readonly router: Router,
    private readonly matDialogRef: MatDialogRef<LoginAndRegDialogComponent>,
    private readonly notificationService: NotificationService,
  ) {
  }

  public passwordFieldType(value: boolean): PasswordFieldType {
    return value ? 'text' : 'password';
  }

  public iconName(value: boolean): PasswordFieldIconType {
    return value ? 'visibility' : 'visibility_off';
  }

  public changePasswordVisibility(): void {
    this.isShowPassword = !this.isShowPassword;
  }

  public formErrorHandler(control: keyof LoginData, error: string): boolean | undefined {
    return this.form.get(control)?.hasError(error);
  }

  public submit(): void {
    const loginData = this.form.getRawValue();

    this.authService.login(loginData).pipe(
      tap( res => {
        this.tokenStorageService.storeToken(res.id_token);
        this.router.navigate(['control-panel']);
        this.matDialogRef.close();
      }),
      switchMap( () => {
        return this.authService.getAccount();
      }),
      tap( res => this.authService.$account.next(res)),
      catchError( error => {
        this.notificationService.openErrorMessage(error.error.AuthenticationException ?? 'Попробуйте ещё раз позднее');
        return EMPTY;
      }),
    ).subscribe();

    // this.authService.getAccount().pipe(
    //   tap( res => this.authService.$account.next(res)),
    //   takeUntil(this.unsubscribe$),
    //   ).subscribe();
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
